























































import Vue from 'vue';
import {
  Component, Inject, Watch, Prop,
} from 'vue-property-decorator';
import { DataTableHeader } from 'vuetify';
import { mapState } from 'vuex';
import { Alert, NoticeClass, AuthStore } from '@kasasa/fbase-components/lib';
import { AuditMessage } from '@/api/auditmessages/AuditMessage';

@Component({
  computed: mapState(['fiId']),
})
export default class AuditDiffSheet extends Vue {
  @Prop({ default: false }) value!: boolean;

  @Prop() auditMessage!: AuditMessage;

  showDiff: boolean = false;

  showMessage: boolean = false;

  contentBefore: string = '';

  contentAfter: string[] = [];

  show: boolean = false;

  fiId!: string;

  loading: boolean = true;

  @Watch('auditMessage')
  auditMessageUpdate() {
    if (this.auditMessage.contentAfter) {
      this.showDiff = this.auditMessage.contentAfter.length > 6;
      this.contentAfter = this.fancyStringDiff(this.auditMessage.contentBefore, this.auditMessage.contentAfter);
      if (this.auditMessage.contentBefore) {
        this.showDiff = this.auditMessage.contentBefore.length > 6;
        this.contentBefore = JSON.stringify(JSON.parse(this.auditMessage.contentBefore), null, '\t');
      } else {
        this.contentBefore = '';
      }
    } else if (this.auditMessage.contentBefore) {
      this.showDiff = this.auditMessage.contentBefore.length > 6;
      this.contentBefore = JSON.stringify(JSON.parse(this.auditMessage.contentBefore), null, '\t');
      this.contentAfter = [];
    } else {
      this.showDiff = false;
    }
    if (this.auditMessage.message) {
      this.showMessage = this.auditMessage.message.length > 6;
    } else {
      this.showMessage = false;
    }
  }

  fancyStringDiff = (before: string | null, after: string): string[] => {
    const oldJson = JSON.stringify(JSON.parse(before || '{}'), null, '\t').split('\n');
    const newJson = JSON.stringify(JSON.parse(after), null, '\t').split('\n');

    const oldJsonKeys = Object.keys(JSON.parse(before || '{}'));
    const newJsonKeys = Object.keys(JSON.parse(after));

    const result: any[] = [];
    result.push({ text: '{\n', color: '#f5f5f5' });
    newJsonKeys.forEach((newJsonKey) => {
      // green for additions, red for deletions
      const displayLine1: any = {};
      const displayLine2: any = {};
      if (newJson.find(element => element.indexOf(newJsonKey) > -1) === null) {
        return;
      }
      const newJsonElement = newJson.find(element => element.indexOf(newJsonKey) > -1) !== undefined ? newJson.find(element => element.indexOf(newJsonKey) > -1) : '';
      const oldJsonElement = oldJson.find(element => element.indexOf(newJsonKey) > -1) !== undefined ? oldJson.find(element => element.indexOf(newJsonKey) > -1) : '';
      if (!oldJsonKeys.find(key => key === newJsonKey)) {
        displayLine1.color = '#c2f7c2';
        displayLine1.text = `\t${newJsonElement}\n`;
        result.push(displayLine1);
      } else if (oldJsonKeys.find(key => key === newJsonKey)) {
        if (oldJsonElement !== newJsonElement) {
          displayLine1.color = '#f7bac6';
          displayLine1.text = `\t${oldJsonElement}\n`;
          result.push(displayLine1);
          displayLine2.color = '#c2f7c2';
          displayLine2.text = `\t${newJsonElement}\n`;
          result.push(displayLine2);
        } else {
          displayLine1.text = `\t${newJsonElement}\n`;
          displayLine1.color = '#f5f5f5';
          result.push(displayLine1);
        }
      }
    });
    result.push({ text: '}\n', color: '#f5f5f5' });
    return result;
  }

  mounted() {
    this.show = this.value;
  }

  @Watch('value')
  onNewValue() {
    this.show = this.value;
  }

  onShowToggle(newValue: boolean) {
    this.show = newValue;
    this.$emit('input', this.show);
  }
}
